import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "launcher", "launcherIcon", "body"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this._handleKeydown = this._handleKeydown.bind(this)
    document.addEventListener("keydown", this._handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._handleKeydown)
  }

  toggle(event) {
    event?.preventDefault?.()
    this.openValue ? this.close() : this.open()
  }

  open() {
    this.openValue = true
    this.element.classList.add("is-open")
    this.panelTarget.setAttribute("aria-hidden", "false")
    this.launcherIconTarget.classList.remove("bi-chat-dots-fill")
    this.launcherIconTarget.classList.add("bi-x-lg")
    this.launcherTarget.setAttribute("aria-label", "Close contact form")

    requestAnimationFrame(() => {
      const firstField = this.panelTarget.querySelector("input[name='support_ticket[name]']")
      firstField?.focus({ preventScroll: true })
    })
  }

  close() {
    this.openValue = false
    this.element.classList.remove("is-open")
    this.panelTarget.setAttribute("aria-hidden", "true")
    this.launcherIconTarget.classList.remove("bi-x-lg")
    this.launcherIconTarget.classList.add("bi-chat-dots-fill")
    this.launcherTarget.setAttribute("aria-label", "Contact us")
  }

  _handleKeydown(event) {
    if (event.key === "Escape" && this.openValue) {
      this.close()
    }
  }
}
